/**
 * TODO: This should be moved to the CMS or calculated periodically from real data
 * Last updated: Nov 13, 2022
 */

const CourseVisits = {
  'amazon-interview': 7411,
  'amazon-sde-interview': 2194,
  'amazon-sdm-interview': 2030,
  'amazon-solution-architect-interview': 523,
  bizops: 1231,
  'data-science-interview': 695,
  'engineering-management': 10581,
  'facebook-pm-interview': 4544,
  'google-pm-interview': 7379,
  pm: 25026,
  pmm: 2234,
  'pm-skills': 2078,
  'product-designer-interview': 1780,
  'software-engineering': 19406,
  'solution-architect-interview': 2340,
  tpm: 10185,
  algorithms: 2996,
  'amazon-leadership-principles': 15342,
  'amazon-pm-overview': 3437,
  analytical: 20154,
  'app-critique': 580,
  'aws-sa-intro': 532,
  behavioral: 5431,
  'behavioral-bizops': 189,
  'bizops-data': 288,
  'bizops-intro': 459,
  'break-into-fintech': 510,
  'common-pmm': 2738,
  'conduct-uer': 830,
  'cross-functional-pmm': 1844,
  'cross-functional-tpm': 8298,
  'data-science': 2110,
  'design-challenges': 102,
  'design-run-experiments': 1404,
  'em-intro': 8208,
  estimation: 21688,
  execution: 10041,
  'facebook-pm-overview': 3850,
  'favorite-product': 8298,
  'fundamentals-analytics': 3054,
  'system-design-interviews': 29982,
  'general-interview': 18272,
  'get-the-interview': 7385,
  'google-collaboration': 516,
  'google-craft-execution': 487,
  'google-pm-overview': 5679,
  'machine-learning': 482,
  'marketing-case': 1230,
  'marketing-strategy': 2167,
  'people-management': 8321,
  'pm-intro': 23587,
  'pm-product-design': 18567,
  'pm-technical': 8931,
  'portfolio-review': 485,
  'product-designer-intro': 695,
  'product-strategy': 12978,
  'program-sense': 6045,
  'project-mgmt-bizops': 224,
  'project-retro': 4475,
  'sa-intro': 1420,
  'solutions-architect-behavioral': 414,
  'stakeholder-management-bizops': 228,
  'strategic-decisions-bizops': 222,
  'swe-behavioral': 3356,
  'swe-intro': 4433,
  'swe-practice': 13034,
  'take-home': 4912,
  'technical-basics-pm': 1392,
  'tpm-intro': 8899,
  'user-insight': 1218,
};

export default CourseVisits;
